import React from 'react';
import { Building2, FileText, CalendarClock } from 'lucide-react';
import { formatDeadline } from '../../utils/helperUtils';
import './KeyInformation.css';

/**
 * Component for displaying project metadata in a structured layout
 */
const KeyInformation = ({ editableData, valuationDisplayVal, valuationVal }) => {
    return (
        <div className="key-info-columns">
            <div className="key-info-column left">
                <div className="column-header-row">
                    <Building2 size={16} color="#FF5526" />
                    <label>CLIENT & PROJECT</label>
                </div>

                <div className="readonly-field">
                    <label>Client</label>
                    <div className="plain-bold-text">{editableData.CLIENT_NAME || 'N/A'}</div>
                </div>
                <div className="readonly-field">
                    <label>Project</label>
                    <div className="plain-bold-text">{editableData.PROPOSAL_TITLE || 'N/A'}</div>
                </div>
                <div className="readonly-field">
                    <label>Industry</label>
                    <div className="plain-bold-text">{editableData.INDUSTRY || 'Not Specified'}</div>
                </div>

                <div className="client-notes-section">
                    <div className="column-header-row">
                        <FileText size={16} color="#FF5526" />
                        <label>CLIENT NOTES</label>
                    </div>
                    <div className="client-notes-content">
                        {editableData.stage_notes || editableData.notes || 'No notes added for this stage.'}
                    </div>
                </div>
            </div>

            <div className="key-info-column right">
                <div className="column-header-row">
                    <CalendarClock size={16} color="#FF5526" />
                    <label>KEY DATES & VALUATION</label>
                </div>

                <div className="readonly-field">
                    <label>Upload Date</label>
                    <div className="plain-bold-text">{formatDeadline(editableData.created_at?.split('T')[0])}</div>
                </div>
                <div className="readonly-field">
                    <label>Proposal Submission</label>
                    <div className="plain-bold-text">{formatDeadline(editableData.PROPOSAL_DEADLINE || editableData.proposal_deadline)}</div>
                </div>
                <div className="readonly-field">
                    <label>Query Deadline</label>
                    <div className="plain-bold-text">{formatDeadline(editableData.QUERY_DEADLINE || editableData.query_deadline)}</div>
                </div>
                <div className="readonly-field">
                    <label>Valuation ({editableData.CURRENCY || editableData.currency || 'USD'})</label>
                    <div className="plain-bold-text">
                        {valuationDisplayVal || valuationVal || '0.00'}
                    </div>
                </div>
                <div className="readonly-field" style={{ width: '50%' }}>
                    <label>Status</label>
                    <div className={`readonly-field-box status-badge ${(editableData.PROPOSAL_STAGE || editableData.proposal_stage || '').toLowerCase().includes('submitted') ? 'approved' : ''}`}>
                        {editableData.PROPOSAL_STAGE || editableData.proposal_stage || 'Analysis'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KeyInformation;
